import { render, staticRenderFns } from "./SucursalForm.vue?vue&type=template&id=c5bdc262&"
import script from "./SucursalForm.vue?vue&type=script&lang=js&"
export * from "./SucursalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports